import { render, staticRenderFns } from "./MyArticleRejected.vue?vue&type=template&id=413f3208&"
import script from "./MyArticleRejected.vue?vue&type=script&lang=js&"
export * from "./MyArticleRejected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports